// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__M5pKB","col":"styles_col__2Xv-K"};